import { TenantEntity } from '../TenantEntity'
import {
  companyFactorySignByCompanyFunc, getCmpIdxByLocal,
  getCompanyByCacheId,
  getCompanyUsers, isExistUserIdByCompany,
  loadCompanyRelated, queryUserRoleByCompany
} from '@/api/company'
import { getCustomerList } from '@/api/partner/customer'
import { getContactList } from '@/api/partner/contact'
import { getManifestAddressList } from '@/api/partner/manifestAddress'
import { getBookingAgentCarrierList } from '@/api/partner/bookingAgentCarrier'
import { getOverseaAgentList, getExChangeAgent } from '@/api/partner/overseaAgent'
import { getShippingList } from '@/api/partner/shipping'
import { getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { ApiCacheManage } from '@/utils/commonUtil'
import $store from '@/store'
import { getWarehouseDetail } from '@/api/company'
import { getAirlineDetail } from '@/api/company'
import { CONTRACTAGREEMENT_CUSTOMER, CONTRACTAGREEMENT_NONE } from '@/class/cargo/model/parameters/ContractConstants'

// getCustomerList缓存管理
const getCustomerListCache = new ApiCacheManage(getCustomerList, params => params.companyUuid)
// Company关联信息缓存
const loadCompanyRelatedCache = new ApiCacheManage(loadCompanyRelated, params => params.companyUuid)

export class Company extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
  get cmpIdx() {
    return this._data.cmpIdx
  }
  set cmpIdx(cmpIdx) {
    this._data.cmpIdx = cmpIdx
  }
  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }
  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }
  get shortName() {
    return this._data.shortName
  }
  set shortName(shortName) {
    this._data.shortName = shortName
  }
  get cnShortName() {
    return this._data.cnShortName
  }
  set cnShortName(cnShortName) {
    this._data.cnShortName = cnShortName
  }
  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }
  get zipCode() {
    return this._data.zipCode
  }
  set zipCode(zipCode) {
    this._data.zipCode = zipCode
  }
  get tel() {
    return this._data.tel
  }
  set tel(tel) {
    this._data.tel = tel
  }
  get fax() {
    return this._data.fax
  }
  set fax(fax) {
    this._data.fax = fax
  }
  get url() {
    return this._data.url
  }
  set url(url) {
    this._data.url = url
  }
  get region() {
    return this._data.region
  }
  set region(region) {
    this._data.region = region
  }
  get rmbAccount() {
    return this._data.rmbAccount
  }
  set rmbAccount(rmbAccount) {
    this._data.rmbAccount = rmbAccount
  }
  get usdAccount() {
    return this._data.usdAccount
  }
  set usdAccount(usdAccount) {
    this._data.usdAccount = usdAccount
  }
  get active() {
    return this._data.active
  }
  set active(active) {
    this._data.active = active
  }
  get global() {
    return this._data.global
  }
  set global(global) {
    this._data.global = global
  }
  get seaCmp() {
    return this._data.seaCmp
  }
  set seaCmp(seaCmp) {
    this._data.seaCmp = seaCmp
  }
  get airCmp() {
    return this._data.airCmp
  }
  set airCmp(airCmp) {
    this._data.airCmp = airCmp
  }
  get seaCmpAgent() {
    return this._data.seaCmpAgent
  }
  set seaCmpAgent(seaCmpAgent) {
    this._data.seaCmpAgent = seaCmpAgent
  }
  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent
  }
  get localAgent() {
    return this._data.localAgent
  }
  set localAgent(localAgent) {
    this._data.localAgent = localAgent
  }
  get overseaAgent() { // 目的港代理
    return this._data.overseaAgent
  }
  set overseaAgent(overseaAgent) {
    this._data.overseaAgent = overseaAgent
  }
  get mustInputScn() {
    return this._data.mustInputScn
  }
  set mustInputScn(mustInputScn) {
    this._data.mustInputScn = mustInputScn
  }
  get designationAgent() {
    return this._data.designationAgent
  }
  set designationAgent(designationAgent) {
    this._data.designationAgent = designationAgent
  }
  get customer() {
    return this._data.customer
  }
  set customer(customer) {
    this._data.customer = customer
  }
  get truckCmp() {
    return this._data.truckCmp
  }
  set truckCmp(truckCmp) {
    this._data.truckCmp = truckCmp
  }
  get customsBroker() {
    return this._data.customsBroker
  }
  set customsBroker(customsBroker) {
    this._data.customsBroker = customsBroker
  }
  get warehouse() {
    return this._data.warehouse
  }
  set warehouse(warehouse) {
    this._data.warehouse = warehouse
  }
  get settlementAgent() {
    return this._data.settlementAgent
  }
  set settlementAgent(settlementAgent) {
    this._data.settlementAgent = settlementAgent
  }
  get other() {
    return this._data.other
  }
  set other(other) {
    this._data.other = other
  }
  get seaExport() {
    return this._data.seaExport
  }
  set seaExport(seaExport) {
    this._data.seaExport = seaExport
  }
  get seaImport() {
    return this._data.seaImport
  }
  set seaImport(seaImport) {
    this._data.seaImport = seaImport
  }
  get airExport() {
    return this._data.airExport
  }
  set airExport(airExport) {
    this._data.airExport = airExport
  }
  get airImport() {
    return this._data.airImport
  }
  set airImport(airImport) {
    this._data.airImport = airImport
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get linkedBranchId() {
    return this._data.linkedBranchId
  }
  set linkedBranchId(linkedBranchId) {
    this._data.linkedBranchId = linkedBranchId || 0
  }
  get collection() {
    return this._data.collection
  }
  set collection(collection) {
    this._data.collection = collection
  }
  get shipper() {
    return this._data.shipper
  }
  set shipper(shipper) {
    this._data.shipper = shipper
  }
  get consignee() {
    return this._data.consignee
  }
  set consignee(consignee) {
    this._data.consignee = consignee
  }
  get notify() {
    return this._data.notify
  }
  set notify(notify) {
    this._data.notify = notify
  }
  get taxRate() {
    return this._data.taxRate
  }
  set taxRate(taxRate) {
    this._data.taxRate = taxRate
  }
  get scac() {
    return this._data.scac
  }
  set scac(scac) {
    this._data.scac = scac
  }
  get province() {
    return this._data.province
  }
  set province(province) {
    this._data.province = province
  }
  get city() {
    return this._data.city
  }
  set city(city) {
    this._data.city = city
  }
  get districts() {
    return this._data.districts
  }
  set districts(districts) {
    this._data.districts = districts
  }
  get detailedAddress() {
    return this._data.detailedAddress
  }
  set detailedAddress(detailedAddress) {
    this._data.detailedAddress = detailedAddress
  }
  get approvedState() {
    return this._data.approvedState
  }
  set approvedState(approvedState) {
    this._data.approvedState = approvedState
  }
  get approvedBy() {
    return this._data.approvedBy
  }
  set approvedBy(approvedBy) {
    this._data.approvedBy = approvedBy
  }
  get dateApproved() {
    return this._data.dateApproved
  }
  set dateApproved(dateApproved) {
    this._data.dateApproved = dateApproved
  }
  get rejectReason() {
    return this._data.rejectReason
  }
  set rejectReason(rejectReason) {
    this._data.rejectReason = rejectReason
  }
  get parentBranchId() {
    return this._data.parentBranchId
  }
  set parentBranchId(parentBranchId) {
    this._data.parentBranchId = parentBranchId
  }
  get relateTenantUuid() {
    return this._data.relateTenantUuid
  }
  set relateTenantUuid(relateTenantUuid) {
    this._data.relateTenantUuid = relateTenantUuid
  }
  get relateTenantId() {
    return this._data.relateTenantId
  }
  set relateTenantId(relateTenantId) {
    this._data.relateTenantId = relateTenantId
  }
  get fba() {
    return this._data.fba
  }
  set fba(fba) {
    this._data.fba = fba
  }
  get relateTenantOfficeId() {
    return this._data.relateTenantOfficeId
  }
  set relateTenantOfficeId(relateTenantOfficeId) {
    this._data.relateTenantOfficeId = relateTenantOfficeId
  }
  get plateCode() {
    return this._data.plateCode
  }
  set plateCode(plateCode) {
    this._data.plateCode = plateCode
  }
  get freightVolume30() {
    return this._data.freightVolume30
  }
  set freightVolume30(freightVolume30) {
    this._data.freightVolume30 = freightVolume30
  }
  get freightVolume60() {
    return this._data.freightVolume60
  }
  set freightVolume60(freightVolume60) {
    this._data.freightVolume60 = freightVolume60
  }
  get freightVolume90() {
    return this._data.freightVolume90
  }
  set freightVolume90(freightVolume90) {
    this._data.freightVolume90 = freightVolume90
  }
  get freightVolumeGt90() {
    return this._data.freightVolumeGt90
  }
  set freightVolumeGt90(freightVolumeGt90) {
    this._data.freightVolumeGt90 = freightVolumeGt90
  }
  get ifOpenSop() {
    return this._data.ifOpenSop
  }
  set ifOpenSop(ifOpenSop) {
    this._data.ifOpenSop = ifOpenSop
  }
  get railwayExport() {
    return this._data.railwayExport
  }
  set railwayExport(railwayExport) {
    this._data.railwayExport = railwayExport
  }
  get portAgent() {
    return this._data.portAgent
  }
  set portAgent(portAgent) {
    this._data.portAgent = portAgent
  }
  get forwardingAgent() {
    return this._data.forwardingAgent
  }
  set forwardingAgent(forwardingAgent) {
    this._data.forwardingAgent = forwardingAgent
  }
  get loadingPlaceCompany() {
    return this._data.loadingPlaceCompany
  }
  set loadingPlaceCompany(loadingPlaceCompany) {
    this._data.loadingPlaceCompany = loadingPlaceCompany
  }
  get signBillPlaceCompany() {
    return this._data.signBillPlaceCompany
  }
  set signBillPlaceCompany(signBillPlaceCompany) {
    this._data.signBillPlaceCompany = signBillPlaceCompany
  }
  get dischargePortCompany() {
    return this._data.dischargePortCompany
  }
  set dischargePortCompany(dischargePortCompany) {
    this._data.dischargePortCompany = dischargePortCompany
  }
  get destinationPortCompany() {
    return this._data.destinationPortCompany
  }
  set destinationPortCompany(destinationPortCompany) {
    this._data.destinationPortCompany = destinationPortCompany
  }
  get factorySign() {
    return this._data.factorySign
  }
  set factorySign(factorySign) {
    this._data.factorySign = factorySign
  }
  get globalAccountUuid() {
    return this._data.globalAccountUuid
  }
  set globalAccountUuid(globalAccountUuid) {
    this._data.globalAccountUuid = globalAccountUuid
  }
  get contractStatus() {
    return this._data.contractStatus
  }
  set contractStatus(contractStatus) {
    this._data.contractStatus = contractStatus
  }
  get sales() {
    return this._data.sales
  }
  set sales(sales) {
    this._data.sales = sales
  }
  get shipping() {
    return this._data.shipping
  }
  set shipping(shipping) {
    this._data.shipping = shipping
  }
  get tradersSign() {
    return this._data.tradersSign
  }
  set tradersSign(tradersSign) {
    this._data.tradersSign = tradersSign
  }
  get parentCompany() {
    return this._data.parentCompany
  }
  set parentCompany(parentCompany) {
    this._data.tradersSign = parentCompany
  }
  get terminalCompany() {
    return this._data.terminalCompany
  }
  set terminalCompany(terminalCompany) {
    this._data.terminalCompany = terminalCompany
  }
  get deliveryAddress() {
    return this._data.deliveryAddress
  }
  set deliveryAddress(deliveryAddress) {
    this._data.deliveryAddress = deliveryAddress
  }
  get multipleBranchId() {
    return this._data.multipleBranchId
  }
  set multipleBranchId(multipleBranchId) {
    this._data.multipleBranchId = multipleBranchId
  }
  get unifiedSign() { // 是否统签
    return this._data.unifiedSign
  }
  set unifiedSign(unifiedSign) {
    this._data.unifiedSign = unifiedSign || false
  }
  get warehouseCode() {
    return this._data.warehouseCode
  }
  get bookingAgentLevel() {
    return this._data.bookingAgentLevel
  }
  set bookingAgentLevel(bookingAgentLevel) {
    this._data.bookingAgentLevel = bookingAgentLevel
  }
  get mscSupplement() {
    return this._data.mscSupplement
  }
  set mscSupplement(mscSupplement) {
    this._data.mscSupplement = mscSupplement || false
  }
  get mscSupplementType() {
    return this._data.mscSupplementType
  }
  set mscSupplementType(mscSupplementType) {
    this._data.mscSupplementType = mscSupplementType
  }
  set warehouseCode(warehouseCode) {
    this._data.warehouseCode = warehouseCode
  }
  get designatedCargoWarehouseNo() {
    return this._data.designatedCargoWarehouseNo
  }
  set designatedCargoWarehouseNo(designatedCargoWarehouseNo) {
    this._data.designatedCargoWarehouseNo = designatedCargoWarehouseNo || false
  }
  get selfCargoWarehouseNo() {
    return this._data.selfCargoWarehouseNo
  }
  set selfCargoWarehouseNo(selfCargoWarehouseNo) {
    this._data.selfCargoWarehouseNo = selfCargoWarehouseNo || false
  }
  get ifAdvancePayment() {
    return this._data.ifAdvancePayment
  }
  set ifAdvancePayment(ifAdvancePayment) {
    this._data.ifAdvancePayment = ifAdvancePayment || false
  }
  get ifExistMblNumberRange() {
    return this._data.ifExistMblNumberRange
  }
  set ifExistMblNumberRange(ifExistMblNumberRange) {
    this._data.ifExistMblNumberRange = ifExistMblNumberRange || false
  }
  get contractLimitEnabled() {
    return this._data.contractLimitEnabled
  }
  set contractLimitEnabled(contractLimitEnabled) {
    this._data.contractLimitEnabled = contractLimitEnabled
  }
  get availableReleaseDays() {
    return this._data.availableReleaseDays
  }
  set availableReleaseDays(availableReleaseDays) {
    this._data.availableReleaseDays = availableReleaseDays
  }
  get defaultAccount() {
    return this._data.defaultAccount
  }
  set defaultAccount(defaultAccount) {
    this._data.defaultAccount = defaultAccount || false
  }
  get shipCompanyUuid() {
    return this._data.shipCompanyUuid
  }
  set shipCompanyUuid(shipCompanyUuid) {
    this._data.shipCompanyUuid = shipCompanyUuid
  }

  get threeCharacterCode() {
    return this._data.threeCharacterCode
  }
  set threeCharacterCode(threeCharacterCode) {
    this._data.threeCharacterCode = threeCharacterCode
  }

  get incoTerm() {
    return this._data.incoTerm
  }
  set incoTerm(incoTerm) {
    this._data.incoTerm = incoTerm
  }

  get specialFeePaymentLimit() {
    return this._data.specialFeePaymentLimit
  }
  set specialFeePaymentLimit(specialFeePaymentLimit) {
    this._data.specialFeePaymentLimit = specialFeePaymentLimit
  }

  async getCustomerDetail() {
    const data = this._data
    if (typeof data.customerDetail !== 'object') {
      data.customerDetail = await getCustomerListCache.execute({ companyUuid: data.uuid }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
    }
    return data.customerDetail
  }
  async getContacts() {
    const data = this._data
    if (typeof data.contacts !== 'object') {
      data.contacts = await getContactList({ companyUuid: data.uuid }).then(res => res.data.list)
    }
    return data.contacts
  }
  async getContactsBycmpIdx() {
    const data = this._data
    if (typeof data.contacts !== 'object' && data.cmpIdx && parseInt(data.cmpIdx) > 0) {
      data.contacts = await getContactList({ cmpIdx: data.cmpIdx }).then(res => res.data.list)
    }
    return data.contacts
  }
  async getMainfestAddress() {
    const data = this._data
    if (typeof data.manifestAddress !== 'object') {
      data.manifestAddress = await getManifestAddressList({ companyUuid: data.uuid }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
    }
    return data.manifestAddress
  }
  async getBookingAgentList(loadBookingAgent = false, paging = true) {
    const data = this._data
    if (typeof data.bookingAgentList !== 'object') {
      data.bookingAgentList = await getBookingAgentCarrierList({ carrierUuid: data.uuid, loadBookingAgent: loadBookingAgent, paging: paging }).then(res => res.data.list)
    }
    return data.bookingAgentList
  }
  async getOverseaAgentDetail() {
    const data = this._data
    if (typeof data.overseaAgentDetail !== 'object') {
      data.overseaAgentDetail = await getOverseaAgentList({ companyUuid: data.uuid }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
    }
    return data.overseaAgentDetail
  }
  async getExChangeAgent() {
    const data = this._data
    if (typeof data.exChangeAgent !== 'object') {
      data.exChangeAgent = await getExChangeAgent({ cmpIdx: data.cmpIdx }).then(res => {
        return res.data.list.length > 0 ? res.data.list[0] : null
      })
    }
    return data.exChangeAgent
  }
  async getShipping() {
    const data = this._data
    if (typeof data.shipping !== 'object') {
      data.shipping = await getShippingList({ companyUuid: data.uuid, pageSize: 100000 }).then(res => res.data.list)
    }
    return data.shipping
  }
  async getCompanyFactorySign() {
    const data = this._data
    data.companyFactorySigns = await companyFactorySignByCompanyFunc({ companyCmpIdx: data.cmpIdx }).then(res => res.data)
    return data.companyFactorySigns
  }
  static async getCompanyById(cmpIdx) {
    if (!cmpIdx || cmpIdx <= 0) return null
    let company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
    if (!company) {
      company = await getCompanyByCacheId(cmpIdx).then(res => res.data)
    }
    return company
  }
  static getCompanyByIdSync(cmpIdx) {
    if (!cmpIdx || cmpIdx <= 0) return null
    const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
    return company || null
  }

  static getCompanyByScac(scac) {
    const companies = getFilterCacheList(basicCacheKeys.basic_data_Company)
    if (companies) {
      for (const company of companies) {
        if (scac != null && scac !== '' && scac === company.scac) {
          return company
        }
      }
    }
    return null
  }

  static async getCompanyName(cmpIdx) {
    const company = await this.getCompanyById(cmpIdx)
    if (company) {
      if ($store.getters.language === 'zh') {
        if (company.chineseName && company.chineseName.trim() === '') {
          return company.englishName || ''
        }
        return company.chineseName || ''
      } else {
        return company.englishName || ''
      }
    }
    return ''
  }
  // 合作伙伴与其对应用户
  static async getCompanyUsers(companyUuid) {
    if (companyUuid) {
      return await getCompanyUsers({ companyUuid }).then(res => res.data)
    } else {
      return []
    }
  }

  static async getCmpIdxByLocal(data) {
    return await getCmpIdxByLocal(data).then(res => res.data)
  }
  async getManifestAddress() {
    const data = this._data
    if (typeof data.manifestAddress !== 'object') {
      const result = await getManifestAddressList({ companyUuid: data.uuid, pageSize: 10 }).then(res => res.data.list)
      if (result && result.length > 0) {
        data.manifestAddress = result[0]
      }
    }
    return data.manifestAddress
  }
  async getWarehouseDetail() {
    const data = this._data
    if (typeof data.warehouseDetail !== 'object') {
      const result = await getWarehouseDetail(data.uuid).then(res => res.data)
      if (result && result.length > 0) {
        data.warehouseDetail = result
      } else {
        data.warehouseDetail = []
      }
    }
    return data.warehouseDetail
  }

  static defaultWarehouse(company) {
    let warehouseDetail = null
    if (!company || !company.warehouseDetail || company.warehouseDetail.length === 0) return warehouseDetail
    for (const warehouse of company.warehouseDetail) {
      if (warehouse.defaultWarehouse) {
        warehouseDetail = warehouse
      }
    }
    if (!warehouseDetail) {
      warehouseDetail = company.warehouseDetail[0]
      warehouseDetail.defaultWarehouse = true
    }
    return warehouseDetail
  }

  async getAirlineDetail() {
    const data = this._data
    if (typeof data.airlineDetail !== 'object') {
      const result = await getAirlineDetail(data.uuid).then(res => res.data)
      if (result && result.length > 0) {
        data.airlineDetail = result[0]
      }
    }
    return data.airlineDetail
  }
  // 加载合作伙伴关联信息
  static async loadCompanyRelated(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, overseaAgents: true, bookingAgentList: true, carrierList: true, events: true, subsidiaryCompany: true, exChangeAgent: true, truckCmp: true }).then(res => res.data)
  }
  // 加载放账信息
  static async loadCreditInfo(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, contract: true }).then(res => res.data.creditInfo)
  }
  // 加载委托单位
  static async loadCustomer(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, contract: true }).then(res => res.data.customer)
  }
  // 加载联系人
  static async loadContact(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, contract: true }).then(res => res.data.contact)
  }
  // 加载合同
  static async loadContract(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, contract: true }).then(res => res.data.contract)
  }
  // 加载客户协议合同
  static async loadAgreementClientContract(companyUuid) {
    let contracts = await loadCompanyRelatedCache.execute({ companyUuid, creditInfo: true, customer: true, contact: true, contract: true }).then(res => res.data.contract)
    if (contracts && contracts.length > 0) {
      contracts = contracts.filter(contract => contract.contractAgreement === CONTRACTAGREEMENT_CUSTOMER.code || contract.contractAgreement === CONTRACTAGREEMENT_NONE.code)
    }
    return contracts
  }
  // 清空缓存
  static clearCache(companyUuid) {
    getCustomerListCache.clear(companyUuid)
    loadCompanyRelatedCache.clear(companyUuid)
  }
  // 加载合作伙伴关联信息
  static async loadCompanyRelatedByParams(params) {
    return await loadCompanyRelated(params).then(res => res.data)
  }
  static async loadDriverInformation(companyUuid) {
    return await loadCompanyRelatedCache.execute({ companyUuid, truckCmp: true }).then(res => res.data.driverInformationList)
  }

  // 加载合作伙伴关联信息
  static async unionAllUserRoleCompany(branch, userId, lob, originCompanyList, allCompanyList) {
    // 查看 当前登录用户所关联的合作伙伴（与上面集合 取并集）
    return await queryUserRoleByCompany({ branch, userId, lob }).then(res => {
      if (res.data && res.data.length > 0) {
        const customerCmpList = allCompanyList.filter(p => res.data.includes(p.uuid))
        console.log('customerCmpList:', customerCmpList)
        if (!originCompanyList || originCompanyList.length === 0) {
          originCompanyList = customerCmpList
        } else {
          originCompanyList = [...new Set([...originCompanyList, ...customerCmpList])]
        }
      }
      return originCompanyList
    })
  }
}
